import Vue from "vue";
import VueRouter from "vue-router";
import { authGuard } from "@tt/vue-auth0";
import i18n from "@/plugins/i18n";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/shipments",
    active: false
  },
  {
    path: "/shipments",
    name: "shipments",
    component: () => import("@/views/ShipmentsOverview.vue"),
    meta: {
      label: i18n.t("shipments.overview.title"),
      active: true,
      render: true,
    },
  }
];

// create router
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// auth check
router.beforeEach(authGuard);

export default router;
